
//export const API_URL = 'http://web.ryukyu.co.jp/api' 
//export const CONTENTS_SRV = 'http://web.ryukyu.co.jp'

//export const API_URL = 'http://test-web.ryukyu.co.jp/api' 
//export const CONTENTS_SRV = 'http://test-web.ryukyu.co.jp'

export const API_URL = 'https://ryukyu-lang.lab.u-ryukyu.ac.jp/api'
export const CONTENTS_SRV = 'https://ryukyu-lang.lab.u-ryukyu.ac.jp'